
import React from 'react';
import DashboardMetricsGrid from '@/components/dashboard/metrics/DashboardMetricsGrid';
import QuickActionsGrid from '@/components/dashboard/quick-actions/QuickActionsGrid';
import { useDashboardData } from '@/components/dashboard/data/useDashboardData';
import { BrandText, BrandCard, CardContent } from '@/components/ui/brand';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DashboardPage: React.FC = () => {
  const {
    subscription,
    activeStaffCount,
    tasksCount,
    isStaffLoading,
    isSubscriptionLoading,
    isActivitiesLoading
  } = useDashboardData();
  
  return (
    <div className="space-y-6 md:space-y-8">
      <div className="mb-6">
        <BrandText size="2xl" weight="semibold" className="mb-2">
          Welcome back
        </BrandText>
        <BrandText muted>
          Here's an overview of your VirtuStaff activities and performance
        </BrandText>
      </div>
      
      <DashboardMetricsGrid
        activeStaffCount={activeStaffCount}
        subscription={subscription}
        tasksCount={tasksCount}
        isStaffLoading={isStaffLoading}
        isSubscriptionLoading={isSubscriptionLoading}
        isActivitiesLoading={isActivitiesLoading}
      />
      
      <QuickActionsGrid />
      
      {activeStaffCount === 0 && (
        <BrandCard 
          className="border-brand/20 border-dashed mt-8 rounded-xl shadow-md p-6"
        >
          <CardContent className="p-6 text-center">
            <div className="mx-auto bg-brand/10 w-20 h-20 rounded-full flex items-center justify-center">
              <Sparkles className="h-10 w-10 text-brand" />
            </div>
            <BrandText size="xl" weight="semibold" className="mb-2">Ready to get started?</BrandText>
            <BrandText muted className="mb-4">
              Hire your first AI staff member to help with your marketing tasks
            </BrandText>
            <Button className="bg-brand text-white font-semibold py-2 px-6 rounded-xl hover:bg-blue-700 transition-colors">
              Hire AI Staff
            </Button>
          </CardContent>
        </BrandCard>
      )}
    </div>
  );
};

export default DashboardPage;
